import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityCodeUser extends Layout {
    checkboxPrimaryAgency: Checkbox;
    panelResponsibilityCodeUser: Panel;
    sourceAgencyLink: DataSource;
    textboxCommDispatcherRole: Textbox;
    textboxCommOrderEntryRole: Textbox;
    textboxDescription: Textbox;
    textboxEffectiveDate: Textbox;
    textboxPayCommissionsWhen: Textbox;
    textboxRowUserId: Textbox;
}
